import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { formatMAD, resolveMediaUrl } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { useI18n } from "@/context/I18nContext";

export default function ProductCard({ product, index = 0 }) {
    const { has, toggle } = useWishlist();
    const { t } = useI18n();
    const isFav = has(product.id);

    const handleFav = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(product.id);
    };

    return (
        <Link
            to={`/product/${product.id}`}
            className="group block"
            data-testid={`product-card-${product.id}`}
            style={{ animationDelay: `${index * 60}ms` }}
        >
            <div className="relative aspect-[4/5] bg-[#0f0f0f] overflow-hidden">
                {product.new_arrival && (
                    <span
                        className="absolute top-3 start-3 z-10 px-2 py-1 bg-white text-black text-[10px] uppercase tracking-[0.2em] font-bold"
                        data-testid={`badge-new-${product.id}`}
                    >
                        {t("section.new_title")}
                    </span>
                )}
                {product.bestseller && !product.new_arrival && (
                    <span
                        className="absolute top-3 start-3 z-10 px-2 py-1 border border-white text-white text-[10px] uppercase tracking-[0.2em] font-bold"
                        data-testid={`badge-best-${product.id}`}
                    >
                        Best
                    </span>
                )}
                <button
                    onClick={handleFav}
                    className={`absolute top-3 end-3 z-10 w-9 h-9 flex items-center justify-center border transition-all ${
                        isFav
                            ? "bg-white text-black border-white"
                            : "bg-black/40 backdrop-blur-sm border-white/20 text-white hover:bg-white hover:text-black opacity-0 group-hover:opacity-100"
                    }`}
                    aria-label={isFav ? t("wishlist.remove") : t("wishlist.add")}
                    data-testid={`wishlist-toggle-${product.id}`}
                >
                    <Heart size={14} strokeWidth={1.5} fill={isFav ? "currentColor" : "none"} />
                </button>
                {product.images?.[0] && (
                    <img
                        src={resolveMediaUrl(product.images[0])}
                        alt={product.name}
                        loading="lazy"
                        className="product-image w-full h-full object-cover"
                    />
                )}
                {product.images?.[1] && (
                    <img
                        src={resolveMediaUrl(product.images[1])}
                        alt=""
                        loading="lazy"
                        className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    />
                )}
            </div>
            <div className="mt-4 flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <p className="text-xs uppercase tracking-[0.2em] text-white/40">
                        {product.category === "tshirt" ? t("product.tshirt") : t("product.cap")}
                    </p>
                    <p className="font-display text-sm sm:text-base font-bold uppercase tracking-tight truncate mt-1">
                        {product.name}
                    </p>
                </div>
                <p className="text-sm font-semibold whitespace-nowrap" data-testid={`product-price-${product.id}`}>
                    {formatMAD(product.price)}
                </p>
            </div>
        </Link>
    );
}
